import React from "react";

import { showDialogAsync } from "../../dialog-queue";
import { EventsDialog } from "./events-dialog";

export const showEventDialogAsync = () =>
	showDialogAsync<undefined | eXpress.creator.calendars.ICalendarDataSources>(
		({ resolve }, { isOpen }) => <EventsDialog open={isOpen} onClose={resolve} />,
		{
			allowOther: true,
		},
	);
